import React from 'react';

import FormikFileUpload from 'components/formik/FormikFileUpload';
import { getFileUploadMessages } from 'utils/fileUtils';
import BaseDraggerContent from 'components/wrappers/BaseFileUpload/BaseDraggerContent';
import UploadList from 'components/wrappers/BaseFileUpload/UploadList';
import { FileUploadTypeEnum } from 'components/wrappers/BaseFileUpload';

const FILE_TYPES = ['XLSX', 'CSV'];

const fileUploadMessages = getFileUploadMessages({
  fileTypes: FILE_TYPES,
});

type Props = {
  fieldName: string;
};

export default React.memo((props: Props) => {
  const { fieldName } = props;

  return (
    <FormikFileUpload
      name={fieldName}
      isDraggable
      maxCount={1}
      defaultFileList={[]}
      acceptedFileSize={10}
      acceptedFileFormat={[
        '.csv',
        'text/csv',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ]}
      getUploadList={UploadList}
      messages={fileUploadMessages}
      typeUploader={FileUploadTypeEnum.Manual}
    >
      {() => <BaseDraggerContent fileTypes={FILE_TYPES} />}
    </FormikFileUpload>
  );
});
